var $window, dealList, expChangeToWebp, fixiOS5, getElementPositions, getFold, getImagesToLoad, getTouchDealCardHeight, progressiveLoad, setTouchImageDimensions, setWebpSetting, touchDealCardHeight, unbindLazyloaderEvent, withinViewport;

touchDealCardHeight = dealList = void 0;

$window = $(window);


/*
 * With IOS5 force loading images when navigating with back button.
 * Non optimal workaround.
 *
 * @param {Array} allLazyImages[] - All images to be lazyloaded
 */

fixiOS5 = function(allLazyImages) {
  if (/(?:iphone|ipod|ipad).*os 5/gi.test(navigator.appVersion)) {
    return $window.one('pageshow', function(event) {
      if (event.originalEvent && event.originalEvent.persisted) {
        return $(allLazyImages).trigger('appear');
      }
    });
  }
};


/*
 * Determine image positions within the document
 *
 * @param   {Array} images[] - Array with images nodes
 * @returns {Array} pos[]    - Array containing the current images position in the document
 */

getElementPositions = function(images) {
  var img, left, pos, ref, right, top;
  pos = [];
  images = images.slice();
  while ((img = images.shift())) {
    ref = img.getBoundingClientRect(), top = ref.top, left = ref.left, right = ref.right;
    pos.push({
      left: left,
      top: top,
      right: right
    });
  }
  return pos;
};


/*
 * Returns the top/bottom coordinate of the visible viewport in doc coords
 *
 * @returns {Object}
 */

getFold = function() {
  return {
    height: window.innerHeight || $window.height(),
    width: window.innerWidth || $window.width()
  };
};


/*
 * Filter out the `images` that are visible, but not yet loaded
 *
 * @param   {Array} images[] - Images to lazyload
 * @returns {Array} toLoad[] - Images that haven't been loaded
 */

getImagesToLoad = function(images) {
  var img, toLoad;
  toLoad = [];
  images = images.slice();
  while ((img = images.shift())) {
    if (!img.loaded && img.offsetHeight) {
      toLoad.push(img);
    }
  }
  return toLoad;
};


/*
 * Returns potential deal card height
 *
 * @returns {Number} height - Deal card height
 */

getTouchDealCardHeight = function() {
  var height;
  height = 0;
  if (typeof Touch !== "undefined" && Touch !== null ? Touch.Utils.getViewportInformation : void 0) {
    height = Touch.Utils.getViewportInformation({
      offset: dealList[0].offsetLeft * 2
    }).dcH;
  }
  return height;
};

expChangeToWebp = function(url, settings) {
  if (settings.webp && url.match(/(img(\d?).grouponcdn.com).*(jpg|png)$/)) {
    Finch.experiment('LS-2718-webp-images', {
      Control: function() {},
      Treatment: function() {
        return url = url.replace(/(q\d+)?(.jpg|.png)$/, '.webp');
      }
    });
  }
  return url;
};


/*
 * Sets html height attribute to touch dealcard images to speed up their rendering
 *
 * @param {Array} collection[] - Collection of images nodes
 */

setTouchImageDimensions = function(collection) {
  var i, img, len;
  window.removeEventListener('load', setTouchImageDimensions);
  if (!(dealList = document.querySelectorAll('.t-deals')).length) {
    return;
  }
  if ((touchDealCardHeight = getTouchDealCardHeight())) {
    for (i = 0, len = collection.length; i < len; i++) {
      img = collection[i];
      if (img.parentNode.parentNode.parentNode.className.match(/t-deals/)) {
        img.height = touchDealCardHeight;
      }
    }
  }
};

setWebpSetting = function(settings, override) {
  var ref;
  settings.webp = override != null ? override : (typeof Modernizr !== "undefined" && Modernizr !== null ? (ref = Modernizr.webp) != null ? ref.valueOf() : void 0 : void 0) || $('html').hasClass('webp') || false;
  return settings;
};


/*
 * Unbind the lazyloader event
 */

unbindLazyloaderEvent = function(settings) {
  if (settings.performantScroll) {
    $(settings.container).off(settings.event);
  }
};


/*
 * Determine if an images is within the viewport + threshold
 *
 * @param   {Object}  fold      - Viewport information
 * @param   {Object}  imgPos    - Image information
 * @param   {Number}  threshold - Threshold to consider loading images within
 * @returns {Boolean}
 */

withinViewport = function(fold, imgPos, threshold) {
  var left, right, top;
  left = imgPos.left, top = imgPos.top, right = imgPos.right;
  if (top <= -threshold) {
    return false;
  }
  if (top >= fold.height + threshold) {
    return false;
  }
  if (left <= -threshold) {
    return false;
  }
  if (right >= fold.width + threshold) {
    return false;
  }
  return true;
};


/*
 * progressive load image
 */

progressiveLoad = function(el, settings) {
  var highQualityImage, highQualitySrc;
  if (!el.loaded && $(el).hasClass('progressive-load') && (highQualitySrc = el.getAttribute('data-high-quality'))) {
    highQualityImage = new Image();
    highQualityImage.style.display = 'none';
    $(highQualityImage).on('load', function() {
      if (el.nodeName === 'IMG') {
        el.src = highQualitySrc;
      } else {
        el.style.backgroundImage = "url('" + highQualitySrc + "')";
      }
      el.style['-webkit-filter'] = 'blur(0px)';
      el.style['filter'] = 'blur(0px)';
      return el.parentNode.removeChild(this);
    });
    highQualityImage.src = expChangeToWebp(highQualitySrc, settings);
    el.parentNode.appendChild(highQualityImage);
  }
  el.loaded = true;
};

(function(jQuery, window, document) {
  "use strict";
  return $.fn.lazyload = function(options) {
    var OPTS, allLazyImages, hasModernizr, initLazyLoading, loadImage, onScroll, requestTick, resizeTimer, settings, ticking;
    if (options == null) {
      options = {};
    }
    allLazyImages = this.get();
    resizeTimer = null;
    OPTS = {
      event: 'scroll.lazyload',
      threshold: 400,
      webp: false,
      skip_invisible: true,
      skip_initial_check: false,
      container: window,
      performantScroll: false,
      isRetina: window.devicePixelRatio && window.devicePixelRatio > 1,
      placeholder: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    };
    settings = _.assign({}, OPTS, options);
    if (settings.resetImageDimensions) {
      setTouchImageDimensions(allLazyImages);
      return;
    }
    ticking = false;

    /*
     * Global scroll handler
     */
    onScroll = function() {
      var fold, imagesNotLoaded, img, pos, positions, threshold;
      ticking = false;
      if (!settings.skip_invisible) {
        $(allLazyImages).trigger('appear');
        unbindLazyloaderEvent(settings);
        return;
      }
      imagesNotLoaded = getImagesToLoad(allLazyImages);
      if (!imagesNotLoaded.length) {
        unbindLazyloaderEvent(settings);
        return;
      }
      fold = getFold();
      allLazyImages = [];
      positions = getElementPositions(imagesNotLoaded);
      threshold = settings.threshold;
      while ((img = imagesNotLoaded.shift())) {
        pos = positions.shift();
        if (withinViewport(fold, pos, threshold)) {
          $(img).triggerHandler('appear');
        } else {
          allLazyImages.push(img);
        }
      }
    };

    /*
     * Image loading handler
     */
    loadImage = function() {
      var url, url2x;
      url = this.getAttribute('data-original');
      if (settings.isRetina && (url2x = this.getAttribute('data-original-2x'))) {
        url = url2x;
      }
      url = expChangeToWebp(url, settings);
      if (this.nodeName === 'IMG') {
        this.src = url;
      } else {
        this.style.backgroundImage = "url('" + url + "')";
      }
      progressiveLoad(this, settings);
    };

    /*
     * Asynchronous scroll handler
     */
    requestTick = function() {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    };
    initLazyLoading = function(onScroll) {
      var images, img;
      if (resizeTimer === null) {
        $window.on('resize', function() {
          if (resizeTimer) {
            clearTimeout(resizeTimer);
          }
          return resizeTimer = setTimeout(onScroll, 100);
        });
      }
      images = allLazyImages.slice();
      while ((img = images.shift())) {
        if (img.nodeName === 'IMG' && img.src === '') {
          img.loaded = false;
          img.src = settings.placeholder;
        }
      }
      setTouchImageDimensions(allLazyImages);
      $(allLazyImages).one('appear', loadImage);
      fixiOS5(allLazyImages);
      window.removeEventListener('scroll', requestTick, {
        passive: true
      });
      window.addEventListener('scroll', requestTick, {
        passive: true
      });
      $(function() {
        settings = setWebpSetting(settings, options != null ? options.webp : void 0);
        if (!settings.skip_initial_check) {
          return requestTick();
        }
      });
      window.removeEventListener('load', setTouchImageDimensions(allLazyImages), {
        passive: true,
        once: true
      });
      return window.addEventListener('load', setTouchImageDimensions(allLazyImages), {
        passive: true,
        once: true
      });
    };
    if (options != null ? options.webp : void 0) {
      settings = setWebpSetting(settings, options.webp);
    }
    hasModernizr = window.Modernizr && typeof Modernizr.on === 'function';
    if (!settings.webp && hasModernizr && ((typeof Modernizr !== "undefined" && Modernizr !== null ? Modernizr.webp : void 0) == null)) {
      return Modernizr.on('webp', function() {
        settings.webp = Modernizr.webp.valueOf();
        return initLazyLoading(onScroll);
      });
    } else {
      return initLazyLoading(onScroll);
    }
  };
})(jQuery, window, document);

module.exports = {
  getElementPositions: getElementPositions,
  getFold: getFold,
  getImagesToLoad: getImagesToLoad,
  getTouchDealCardHeight: getTouchDealCardHeight,
  setTouchImageDimensions: setTouchImageDimensions,
  setWebpSetting: setWebpSetting,
  withinViewport: withinViewport
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9jb3JlL2dycG4tbGF6eWxvYWQuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9jb3JlL2dycG4tbGF6eWxvYWQuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU9BLElBQUE7O0FBQUEsbUJBQUEsR0FBc0IsUUFBQSxHQUFXOztBQUVqQyxPQUFBLEdBQVUsQ0FBQSxDQUFFLE1BQUY7OztBQUVWOzs7Ozs7O0FBTUEsT0FBQSxHQUFVLFNBQUMsYUFBRDtFQUNSLElBQUksOEJBQStCLENBQUMsSUFBakMsQ0FBc0MsU0FBUyxDQUFDLFVBQWhELENBQUg7V0FDRSxPQUFPLENBQUMsR0FBUixDQUFZLFVBQVosRUFBd0IsU0FBQyxLQUFEO01BQ3RCLElBQUcsS0FBSyxDQUFDLGFBQU4sSUFBd0IsS0FBSyxDQUFDLGFBQWEsQ0FBQyxTQUEvQztlQUNFLENBQUEsQ0FBRSxhQUFGLENBQWdCLENBQUMsT0FBakIsQ0FBeUIsUUFBekIsRUFERjs7SUFEc0IsQ0FBeEIsRUFERjs7QUFEUTs7O0FBTVY7Ozs7Ozs7QUFNQSxtQkFBQSxHQUFzQixTQUFDLE1BQUQ7QUFDcEIsTUFBQTtFQUFBLEdBQUEsR0FBTTtFQUNOLE1BQUEsR0FBUyxNQUFNLENBQUMsS0FBUCxDQUFBO0FBQ1QsU0FBTSxDQUFDLEdBQUEsR0FBTSxNQUFNLENBQUMsS0FBUCxDQUFBLENBQVAsQ0FBTjtJQUNFLE1BQXFCLEdBQUcsQ0FBQyxxQkFBSixDQUFBLENBQXJCLEVBQUMsYUFBRCxFQUFNLGVBQU4sRUFBWTtJQUNaLEdBQUcsQ0FBQyxJQUFKLENBQVM7TUFBRSxNQUFBLElBQUY7TUFBUSxLQUFBLEdBQVI7TUFBYSxPQUFBLEtBQWI7S0FBVDtFQUZGO1NBR0E7QUFOb0I7OztBQVF0Qjs7Ozs7O0FBS0EsT0FBQSxHQUFVLFNBQUE7U0FDUjtJQUFBLE1BQUEsRUFBUSxNQUFNLENBQUMsV0FBUCxJQUFzQixPQUFPLENBQUMsTUFBUixDQUFBLENBQTlCO0lBQ0EsS0FBQSxFQUFRLE1BQU0sQ0FBQyxVQUFQLElBQXFCLE9BQU8sQ0FBQyxLQUFSLENBQUEsQ0FEN0I7O0FBRFE7OztBQUlWOzs7Ozs7O0FBTUEsZUFBQSxHQUFrQixTQUFDLE1BQUQ7QUFDaEIsTUFBQTtFQUFBLE1BQUEsR0FBUztFQUNULE1BQUEsR0FBUyxNQUFNLENBQUMsS0FBUCxDQUFBO0FBRVQsU0FBTSxDQUFDLEdBQUEsR0FBTSxNQUFNLENBQUMsS0FBUCxDQUFBLENBQVAsQ0FBTjtJQUNFLElBQUcsQ0FBSSxHQUFHLENBQUMsTUFBUixJQUFtQixHQUFHLENBQUMsWUFBMUI7TUFDRSxNQUFNLENBQUMsSUFBUCxDQUFZLEdBQVosRUFERjs7RUFERjtTQUdBO0FBUGdCOzs7QUFTbEI7Ozs7OztBQUtBLHNCQUFBLEdBQXlCLFNBQUE7QUFDdkIsTUFBQTtFQUFBLE1BQUEsR0FBUztFQUNULHFEQUFHLEtBQUssQ0FBRSxLQUFLLENBQUMsK0JBQWhCO0lBR0UsTUFBQSxHQUFTLEtBQUssQ0FBQyxLQUFLLENBQUMsc0JBQVosQ0FBbUM7TUFBQyxNQUFBLEVBQVEsUUFBUyxDQUFBLENBQUEsQ0FBRSxDQUFDLFVBQVosR0FBeUIsQ0FBbEM7S0FBbkMsQ0FBd0UsQ0FBQyxJQUhwRjs7U0FJQTtBQU51Qjs7QUFRekIsZUFBQSxHQUFrQixTQUFDLEdBQUQsRUFBTSxRQUFOO0VBQ2hCLElBQUcsUUFBUSxDQUFDLElBQVQsSUFBa0IsR0FBRyxDQUFDLEtBQUosQ0FBVSx1Q0FBVixDQUFyQjtJQUNFLEtBQUssQ0FBQyxVQUFOLENBQWlCLHFCQUFqQixFQUNFO01BQUEsT0FBQSxFQUFTLFNBQUEsR0FBQSxDQUFUO01BQ0EsU0FBQSxFQUFXLFNBQUE7ZUFBRyxHQUFBLEdBQU0sR0FBRyxDQUFDLE9BQUosQ0FBWSxxQkFBWixFQUFtQyxPQUFuQztNQUFULENBRFg7S0FERixFQURGOztTQUlBO0FBTGdCOzs7QUFRbEI7Ozs7OztBQUtBLHVCQUFBLEdBQTBCLFNBQUMsVUFBRDtBQUN4QixNQUFBO0VBQUEsTUFBTSxDQUFDLG1CQUFQLENBQTJCLE1BQTNCLEVBQW1DLHVCQUFuQztFQUVBLElBQVUsQ0FBSSxDQUFDLFFBQUEsR0FBVyxRQUFRLENBQUMsZ0JBQVQsQ0FBMEIsVUFBMUIsQ0FBWixDQUFrRCxDQUFDLE1BQWpFO0FBQUEsV0FBQTs7RUFFQSxJQUFHLENBQUMsbUJBQUEsR0FBc0Isc0JBQUEsQ0FBQSxDQUF2QixDQUFIO0FBQ0UsU0FBQSw0Q0FBQTs7TUFHRSxJQUFHLEdBQUcsQ0FBQyxVQUFVLENBQUMsVUFBVSxDQUFDLFVBQVUsQ0FBQyxTQUFTLENBQUMsS0FBL0MsQ0FBcUQsU0FBckQsQ0FBSDtRQUNFLEdBQUcsQ0FBQyxNQUFKLEdBQWEsb0JBRGY7O0FBSEYsS0FERjs7QUFMd0I7O0FBYTFCLGNBQUEsR0FBaUIsU0FBQyxRQUFELEVBQVcsUUFBWDtBQUNmLE1BQUE7RUFBQSxRQUFRLENBQUMsSUFBVCxHQUFtQixnQkFBSCxHQUFrQixRQUFsQixpR0FBK0MsQ0FBRSxPQUFqQixDQUFBLG9CQUFBLElBQThCLENBQUEsQ0FBRSxNQUFGLENBQVMsQ0FBQyxRQUFWLENBQW1CLE1BQW5CLENBQTlCLElBQTREO1NBQzVHO0FBRmU7OztBQUlqQjs7OztBQUdBLHFCQUFBLEdBQXdCLFNBQUMsUUFBRDtFQUN0QixJQUE2QyxRQUFRLENBQUMsZ0JBQXREO0lBQUEsQ0FBQSxDQUFFLFFBQVEsQ0FBQyxTQUFYLENBQXFCLENBQUMsR0FBdEIsQ0FBMEIsUUFBUSxDQUFDLEtBQW5DLEVBQUE7O0FBRHNCOzs7QUFJeEI7Ozs7Ozs7OztBQVFBLGNBQUEsR0FBaUIsU0FBQyxJQUFELEVBQU8sTUFBUCxFQUFlLFNBQWY7QUFDZixNQUFBO0VBQUMsa0JBQUQsRUFBTyxnQkFBUCxFQUFZO0VBRVosSUFBaUIsR0FBQSxJQUFPLENBQUMsU0FBekI7QUFBQSxXQUFPLE1BQVA7O0VBRUEsSUFBaUIsR0FBQSxJQUFPLElBQUksQ0FBQyxNQUFMLEdBQWMsU0FBdEM7QUFBQSxXQUFPLE1BQVA7O0VBRUEsSUFBaUIsSUFBQSxJQUFRLENBQUMsU0FBMUI7QUFBQSxXQUFPLE1BQVA7O0VBRUEsSUFBaUIsS0FBQSxJQUFTLElBQUksQ0FBQyxLQUFMLEdBQWEsU0FBdkM7QUFBQSxXQUFPLE1BQVA7O0FBRUEsU0FBTztBQVhROzs7QUFhakI7Ozs7QUFHQSxlQUFBLEdBQWtCLFNBQUMsRUFBRCxFQUFLLFFBQUw7QUFDaEIsTUFBQTtFQUFBLElBQUcsQ0FBSSxFQUFFLENBQUMsTUFBUCxJQUFrQixDQUFBLENBQUUsRUFBRixDQUFLLENBQUMsUUFBTixDQUFlLGtCQUFmLENBQWxCLElBQXlELENBQUEsY0FBQSxHQUFpQixFQUFFLENBQUMsWUFBSCxDQUFnQixtQkFBaEIsQ0FBakIsQ0FBNUQ7SUFDRSxnQkFBQSxHQUF1QixJQUFBLEtBQUEsQ0FBQTtJQUN2QixnQkFBZ0IsQ0FBQyxLQUFLLENBQUMsT0FBdkIsR0FBaUM7SUFDakMsQ0FBQSxDQUFFLGdCQUFGLENBQW1CLENBQUMsRUFBcEIsQ0FBdUIsTUFBdkIsRUFBK0IsU0FBQTtNQUM3QixJQUFHLEVBQUUsQ0FBQyxRQUFILEtBQWUsS0FBbEI7UUFDRSxFQUFFLENBQUMsR0FBSCxHQUFTLGVBRFg7T0FBQSxNQUFBO1FBR0UsRUFBRSxDQUFDLEtBQUssQ0FBQyxlQUFULEdBQTJCLE9BQUEsR0FBUyxjQUFULEdBQXlCLEtBSHREOztNQUtBLEVBQUUsQ0FBQyxLQUFNLENBQUEsZ0JBQUEsQ0FBVCxHQUE2QjtNQUM3QixFQUFFLENBQUMsS0FBTSxDQUFBLFFBQUEsQ0FBVCxHQUFxQjthQUVyQixFQUFFLENBQUMsVUFBVSxDQUFDLFdBQWQsQ0FBMEIsSUFBMUI7SUFUNkIsQ0FBL0I7SUFXQSxnQkFBZ0IsQ0FBQyxHQUFqQixHQUF1QixlQUFBLENBQWdCLGNBQWhCLEVBQWdDLFFBQWhDO0lBQ3ZCLEVBQUUsQ0FBQyxVQUFVLENBQUMsV0FBZCxDQUEwQixnQkFBMUIsRUFmRjs7RUFpQkEsRUFBRSxDQUFDLE1BQUgsR0FBWTtBQWxCSTs7QUFxQmYsQ0FBQSxTQUFDLE1BQUQsRUFBUyxNQUFULEVBQWlCLFFBQWpCO0VBQ0Q7U0FFQSxDQUFDLENBQUMsRUFBRSxDQUFDLFFBQUwsR0FBZ0IsU0FBQyxPQUFEO0FBQ2QsUUFBQTs7TUFEZSxVQUFVOztJQUN6QixhQUFBLEdBQWdCLElBQUMsQ0FBQSxHQUFELENBQUE7SUFDaEIsV0FBQSxHQUFjO0lBRWQsSUFBQSxHQUNFO01BQUEsS0FBQSxFQUFPLGlCQUFQO01BQ0EsU0FBQSxFQUFXLEdBRFg7TUFFQSxJQUFBLEVBQU0sS0FGTjtNQUdBLGNBQUEsRUFBZ0IsSUFIaEI7TUFJQSxrQkFBQSxFQUFvQixLQUpwQjtNQUtBLFNBQUEsRUFBVyxNQUxYO01BTUEsZ0JBQUEsRUFBa0IsS0FObEI7TUFPQSxRQUFBLEVBQVUsTUFBTSxDQUFDLGdCQUFQLElBQTRCLE1BQU0sQ0FBQyxnQkFBUCxHQUEwQixDQVBoRTtNQVFBLFdBQUEsRUFBYSw0RUFSYjs7SUFVRixRQUFBLEdBQVcsQ0FBQyxDQUFDLE1BQUYsQ0FBUyxFQUFULEVBQWEsSUFBYixFQUFtQixPQUFuQjtJQUlYLElBQUcsUUFBUSxDQUFDLG9CQUFaO01BQ0UsdUJBQUEsQ0FBd0IsYUFBeEI7QUFDQSxhQUZGOztJQUlBLE9BQUEsR0FBVTs7QUFFVjs7O0lBR0EsUUFBQSxHQUFXLFNBQUE7QUFDVCxVQUFBO01BQUEsT0FBQSxHQUFVO01BQ1YsSUFBQSxDQUFPLFFBQVEsQ0FBQyxjQUFoQjtRQUNFLENBQUEsQ0FBRSxhQUFGLENBQWdCLENBQUMsT0FBakIsQ0FBeUIsUUFBekI7UUFDQSxxQkFBQSxDQUFzQixRQUF0QjtBQUNBLGVBSEY7O01BS0EsZUFBQSxHQUFrQixlQUFBLENBQWdCLGFBQWhCO01BRWxCLElBQUEsQ0FBTyxlQUFlLENBQUMsTUFBdkI7UUFDRSxxQkFBQSxDQUFzQixRQUF0QjtBQUNBLGVBRkY7O01BSUEsSUFBQSxHQUFPLE9BQUEsQ0FBQTtNQUdQLGFBQUEsR0FBZ0I7TUFDaEIsU0FBQSxHQUFZLG1CQUFBLENBQW9CLGVBQXBCO01BQ1osU0FBQSxHQUFZLFFBQVEsQ0FBQztBQUNyQixhQUFNLENBQUMsR0FBQSxHQUFNLGVBQWUsQ0FBQyxLQUFoQixDQUFBLENBQVAsQ0FBTjtRQUNFLEdBQUEsR0FBTSxTQUFTLENBQUMsS0FBVixDQUFBO1FBQ04sSUFBRyxjQUFBLENBQWUsSUFBZixFQUFxQixHQUFyQixFQUEwQixTQUExQixDQUFIO1VBQ0UsQ0FBQSxDQUFFLEdBQUYsQ0FBTSxDQUFDLGNBQVAsQ0FBc0IsUUFBdEIsRUFERjtTQUFBLE1BQUE7VUFHRSxhQUFhLENBQUMsSUFBZCxDQUFtQixHQUFuQixFQUhGOztNQUZGO0lBbkJTOztBQTJCWDs7O0lBR0EsU0FBQSxHQUFZLFNBQUE7QUFDVixVQUFBO01BQUEsR0FBQSxHQUFNLElBQUMsQ0FBQSxZQUFELENBQWMsZUFBZDtNQUVOLElBQUcsUUFBUSxDQUFDLFFBQVQsSUFBc0IsQ0FBQyxLQUFBLEdBQVEsSUFBQyxDQUFBLFlBQUQsQ0FBYyxrQkFBZCxDQUFULENBQXpCO1FBQ0UsR0FBQSxHQUFNLE1BRFI7O01BR0EsR0FBQSxHQUFNLGVBQUEsQ0FBZ0IsR0FBaEIsRUFBcUIsUUFBckI7TUFFTixJQUFHLElBQUMsQ0FBQSxRQUFELEtBQWEsS0FBaEI7UUFDRSxJQUFDLENBQUEsR0FBRCxHQUFPLElBRFQ7T0FBQSxNQUFBO1FBR0UsSUFBQyxDQUFBLEtBQUssQ0FBQyxlQUFQLEdBQXlCLE9BQUEsR0FBUyxHQUFULEdBQWMsS0FIekM7O01BS0EsZUFBQSxDQUFnQixJQUFoQixFQUFzQixRQUF0QjtJQWJVOztBQWdCWjs7O0lBR0EsV0FBQSxHQUFjLFNBQUE7TUFDWixJQUFHLENBQUksT0FBUDtRQUNFLHFCQUFBLENBQXNCLFFBQXRCO1FBQ0EsT0FBQSxHQUFVLEtBRlo7O0lBRFk7SUFNZCxlQUFBLEdBQWtCLFNBQUMsUUFBRDtBQUdoQixVQUFBO01BQUEsSUFBRyxXQUFBLEtBQWUsSUFBbEI7UUFDRSxPQUFPLENBQUMsRUFBUixDQUFXLFFBQVgsRUFBcUIsU0FBQTtVQUNuQixJQUErQixXQUEvQjtZQUFBLFlBQUEsQ0FBYSxXQUFiLEVBQUE7O2lCQUNBLFdBQUEsR0FBYyxVQUFBLENBQVcsUUFBWCxFQUFxQixHQUFyQjtRQUZLLENBQXJCLEVBREY7O01BTUEsTUFBQSxHQUFTLGFBQWEsQ0FBQyxLQUFkLENBQUE7QUFDVCxhQUFNLENBQUMsR0FBQSxHQUFNLE1BQU0sQ0FBQyxLQUFQLENBQUEsQ0FBUCxDQUFOO1FBRUUsSUFBRyxHQUFHLENBQUMsUUFBSixLQUFnQixLQUFoQixJQUEwQixHQUFHLENBQUMsR0FBSixLQUFXLEVBQXhDO1VBQ0UsR0FBRyxDQUFDLE1BQUosR0FBYTtVQUNiLEdBQUcsQ0FBQyxHQUFKLEdBQVUsUUFBUSxDQUFDLFlBRnJCOztNQUZGO01BTUEsdUJBQUEsQ0FBd0IsYUFBeEI7TUFHQSxDQUFBLENBQUUsYUFBRixDQUFnQixDQUFDLEdBQWpCLENBQXFCLFFBQXJCLEVBQStCLFNBQS9CO01BRUEsT0FBQSxDQUFRLGFBQVI7TUFHQSxNQUFNLENBQUMsbUJBQVAsQ0FBMkIsUUFBM0IsRUFBcUMsV0FBckMsRUFBa0Q7UUFBQyxPQUFBLEVBQVMsSUFBVjtPQUFsRDtNQUNBLE1BQU0sQ0FBQyxnQkFBUCxDQUF3QixRQUF4QixFQUFrQyxXQUFsQyxFQUErQztRQUFDLE9BQUEsRUFBUyxJQUFWO09BQS9DO01BRUEsQ0FBQSxDQUFFLFNBQUE7UUFDQSxRQUFBLEdBQVcsY0FBQSxDQUFlLFFBQWYsb0JBQXlCLE9BQU8sQ0FBRSxhQUFsQztRQUNYLElBQUEsQ0FBTyxRQUFRLENBQUMsa0JBQWhCO2lCQUNFLFdBQUEsQ0FBQSxFQURGOztNQUZBLENBQUY7TUFLQSxNQUFNLENBQUMsbUJBQVAsQ0FBMkIsTUFBM0IsRUFBbUMsdUJBQUEsQ0FBd0IsYUFBeEIsQ0FBbkMsRUFBMkU7UUFBQyxPQUFBLEVBQVMsSUFBVjtRQUFnQixJQUFBLEVBQU0sSUFBdEI7T0FBM0U7YUFDQSxNQUFNLENBQUMsZ0JBQVAsQ0FBd0IsTUFBeEIsRUFBZ0MsdUJBQUEsQ0FBd0IsYUFBeEIsQ0FBaEMsRUFBd0U7UUFBQyxPQUFBLEVBQVMsSUFBVjtRQUFnQixJQUFBLEVBQU0sSUFBdEI7T0FBeEU7SUFqQ2dCO0lBbUNsQixzQkFBRyxPQUFPLENBQUUsYUFBWjtNQUNFLFFBQUEsR0FBVyxjQUFBLENBQWUsUUFBZixFQUF5QixPQUFPLENBQUMsSUFBakMsRUFEYjs7SUFFQSxZQUFBLEdBQWUsTUFBTSxDQUFDLFNBQVAsSUFBcUIsT0FBTyxTQUFTLENBQUMsRUFBakIsS0FBdUI7SUFDM0QsSUFBRyxDQUFJLFFBQVEsQ0FBQyxJQUFiLElBQXNCLFlBQXRCLElBQTJDLDRGQUE5QzthQUVFLFNBQVMsQ0FBQyxFQUFWLENBQWEsTUFBYixFQUFxQixTQUFBO1FBQ25CLFFBQVEsQ0FBQyxJQUFULEdBQWdCLFNBQVMsQ0FBQyxJQUFJLENBQUMsT0FBZixDQUFBO2VBQ2hCLGVBQUEsQ0FBZ0IsUUFBaEI7TUFGbUIsQ0FBckIsRUFGRjtLQUFBLE1BQUE7YUFPRSxlQUFBLENBQWdCLFFBQWhCLEVBUEY7O0VBekhjO0FBSGYsQ0FBQSxDQUFILENBQUksTUFBSixFQUFZLE1BQVosRUFBb0IsUUFBcEI7O0FBc0lBLE1BQU0sQ0FBQyxPQUFQLEdBQWlCO0VBQ2YscUJBQUEsbUJBRGU7RUFFZixTQUFBLE9BRmU7RUFHZixpQkFBQSxlQUhlO0VBSWYsd0JBQUEsc0JBSmU7RUFLZix5QkFBQSx1QkFMZTtFQU1mLGdCQUFBLGNBTmU7RUFPZixnQkFBQSxjQVBlIn0=
